import React from "react";
import { useTabContext } from "../context/context";
import AdvancedSearch from "../components/AdvancedSearch";
import Accepting from "../components/Accepting";
import AvailabilityTable from "../components/AvailabilityTable";

const Availability = () => {
  const { provID, providerInfo, isReferral } = useTabContext();

  //console.log("isReferral on availability", isReferral);

  // console.log("provID on availability", provID);
  // console.log("providerInfo on availability", providerInfo);

  return (
    <div className="v3-db-tab-1">
      <AdvancedSearch />
      {!isReferral && <Accepting />}
      {!isReferral && <AvailabilityTable />}
    </div>
  );
};

export default Availability;
